import { render, staticRenderFns } from "./table-pop.vue?vue&type=template&id=25398218&scoped=true"
import script from "./table-pop.vue?vue&type=script&lang=ts"
export * from "./table-pop.vue?vue&type=script&lang=ts"
import style0 from "./table-pop.vue?vue&type=style&index=0&id=25398218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25398218",
  null
  
)

export default component.exports